var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.accProductTemplates,"service":_vm.fetchAccProductTemplates,"allow-search":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('ListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('ListItem',{attrs:{"acc-product-template":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }